/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, March 30th 2024, 7:31:38 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image } from "ui-widgets";
import { MediaAssetType } from "lib/schemas";

export const EmptyLibraryCTA = ({ mediaType }: { mediaType: MediaAssetType }) => {
  let title = "No data uploaded yet";
  let description = "Upload data to get started";
  switch (mediaType) {
    case "image":
      title = "No images uploaded yet";
      description =
        "Get started uploading images to your organization's media library so that you can reuse those images within the Onestop platform.";
      break;
    case "file":
      title = "No files uploaded yet";
      description =
        "Get started uploading files to your organization's media library so that you can reuse those files within the Onestop platform.";
      break;
  }
  return (
    <EmptyStateActionWrapper
      title={title}
      description={description}
      illustrationGraphic={<Image className="image-style-A" src="/img/folder.png" alt="Onestop Admin" />}
    />
  );
};
